import type { WorkflowAssetsPreview, WorkflowAssetTask, AssetsConfirmSnapshot } from '../../types/filmWorkflowAssets';
export function assetsSnapshot(p: WorkflowAssetsPreview): AssetsConfirmSnapshot | undefined {
    if (!p.enabled)
        return undefined;
    if (!p.sourceHash)
        throw Error('Không đọc được nguồn tài sản');
    return { baseHash: p.hash, sourceHash: p.sourceHash };
}
export const requiredAssetTasks = (p: WorkflowAssetsPreview) => (p.assetTasks || []).filter(t => t.required && t.state !== 'READY');
export function assetsConfirmText(p: WorkflowAssetsPreview): string {
    const tasks = requiredAssetTasks(p), images = p.subjects.filter(s => (!s.workKind || s.workKind === 'IMAGE') && s.readiness === 'READY').length;
    return [`Ứng viên đã biết: ${(p.knownCandidates || []).join(', ') || 'Máy sẽ rà nguồn'}.`, `${images} ảnh READY dùng lại.`, ...tasks.map(t => `${t.name || t.key} · ${t.kind === 'KYC' ? 'AVIS miễn phí, asset không xoá được' : t.kind === 'PREPARE' ? 'chuẩn bị hồ sơ bằng AI' : 'ảnh cần hoàn tất'}`), 'Máy sẽ rà thêm từ nguồn; danh sách có thể bổ sung trong lượt chạy. Tối đa 30 lượt AI chữ và ảnh cộng lại; kết quả đã có được dùng lại.'].join('\n');
}
export function taskCta(t: WorkflowAssetTask, code?: string): string {
    if (code === 'KYC_UNKNOWN' || code === 'KYC_BLOCKED')
        return 'Đối soát AVIS';
    if (code === 'KYC_REJECTED')
        return 'Đổi ảnh và đăng ký lại';
    if (code === 'KYC_IMAGE_CHANGED')
        return 'Dùng ảnh hiện tại';
    if (t.kind === 'KYC')
        return 'Đăng ký/kiểm tra AVIS';
    if (t.kind === 'VOICE')
        return 'Chọn giọng (tuỳ chọn)';
    if (t.kind === 'STYLE')
        return t.state === 'DRAFT' ? 'Duyệt bước sẽ làm luôn' : 'Đề xuất hồ sơ (AI trả phí)';
    return 'Hoàn tất tài sản';
}
